import 'core-js/client/shim';
import 'reflect-metadata';
import 'web-animations-js';
require('zone.js/dist/zone');

import 'ts-helpers';
import 'whatwg-fetch';

if (process.env.ENV === 'build') {
  // Production

} else {
  // Development

  Error['stackTraceLimit'] = Infinity;

  require('zone.js/dist/long-stack-trace-zone');
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/polyfills.ts